import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const Relaxation23 = () => {
  return (
    <div className="w-full ">
      {/* RELAXATION OPTIONS SECTION */}
      <section className="bg-[#F5F5F5] h-screen shadow-[0_3px_10px_rgb(0,0,0,0.2)] m-4 rounded-md">
        <div className="h-full px-3 py-4 overflow-y-auto">
          <div>
            <p className="text-[#314C1C] text-2xl px-4 pb-3 font-bold">
              RELAXATION
            </p>
            <p className="text-[#314C1C] text-lg px-4 font-semibold ">
              EXPLORE YOUR RELAXATION TECHNIQUES
            </p>
          </div>
          <div className="text-center">
            <div className="p-8 pt-20 space-y-5 mx-5">
              <Link to="../relaxation24">
                <button
                  type="button"
                  className="text-[#314C1C] font-medium border-2 border-[#314C1C] w-full p-2 rounded-md mb-5"
                >
                  Quick Relaxation
                </button>
              </Link>
              <a
                href="https://music.youtube.com/watch?v=QHfy9J89mmY&si=_exCUpdhKFRWRvmh"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button
                  type="button"
                  className="text-[#314C1C] font-medium border-2 border-[#314C1C] w-full p-2 rounded-md mb-5"
                >
                  Stress Reduction
                </button>
              </a>
              <a
                href="https://music.youtube.com/watch?v=xO9q0ioUwGc&si=xc_dhXt-kADT7-EV"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button
                  type="button"
                  className="text-[#314C1C] font-medium border-2 border-[#314C1C] w-full p-2 rounded-md mb-5"
                >
                  Mindfulness Meditation
                </button>
              </a>
              <a
                href="https://music.youtube.com/watch?v=koRbYQyPU0U&si=ssu-U_ZjXNyrVElX"
                target="_blank"
              >
                <button
                  type="button"
                  className="text-[#314C1C] font-medium border-2 border-[#314C1C] w-full p-2 rounded-md"
                >
                  Calming Soundscape
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Relaxation23;
